var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      { staticClass: "table tablerow continuous-report-summary-summary-table" },
      [
        _c(
          "caption",
          [
            _c("plain-text-control", {
              attrs: { title: _vm.title, required: _vm.isRevisionTable }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { id: _vm.title + "_0" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "ContinuousReportSummary.Collaboration.CustomerGuidance.PartnerName"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("th", { attrs: { id: _vm.title + "_1" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "ContinuousReportSummary.Collaboration.CustomerGuidance.PartnerType"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "right", attrs: { id: _vm.title + "_2" } },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReportSummary.Collaboration.CustomerGuidance.RedirectedToPartnerCount"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "right", attrs: { id: _vm.title + "_3" } },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReportSummary.Collaboration.CustomerGuidance.RedirectedFromPartnerCount"
                      )
                    )
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.totals, function(partner, i) {
            return _c(
              "tr",
              {
                key: "partner-" + i,
                staticClass: "aidapplications-main-row border-0"
              },
              [
                _c("th", { staticClass: "row-heading normal" }, [
                  _c("span", [_vm._v(_vm._s(partner.partnerName))])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "normal" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.getPartnerType(partner.partnerType)))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: [
                      _vm.isRevisionTable ? "right input-cell" : "normal",
                      "w-25"
                    ]
                  },
                  [
                    _vm.isRevisionTable
                      ? _c("numeric-input-control", {
                          attrs: {
                            required: "",
                            disabled: !_vm.isRevisionTable || _vm.isReadOnly,
                            placeholderKey: "EnterValue",
                            labelledBy: _vm.title + "_2"
                          },
                          model: {
                            value: partner.redirectedCustomersToPartnerCount,
                            callback: function($$v) {
                              _vm.$set(
                                partner,
                                "redirectedCustomersToPartnerCount",
                                $$v
                              )
                            },
                            expression:
                              "partner.redirectedCustomersToPartnerCount"
                          }
                        })
                      : _c("span", { staticClass: "right" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatNumber")(
                                partner.redirectedCustomersToPartnerCount
                              )
                            )
                          )
                        ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: [
                      _vm.isRevisionTable ? "right input-cell" : "normal",
                      "w-25"
                    ]
                  },
                  [
                    _vm.isRevisionTable
                      ? _c("numeric-input-control", {
                          attrs: {
                            required: "",
                            disabled: !_vm.isRevisionTable || _vm.isReadOnly,
                            placeholderKey: "EnterValue",
                            labelledBy: _vm.title + "_3"
                          },
                          model: {
                            value: partner.redirectedCustomersFromPartnerCount,
                            callback: function($$v) {
                              _vm.$set(
                                partner,
                                "redirectedCustomersFromPartnerCount",
                                $$v
                              )
                            },
                            expression:
                              "partner.redirectedCustomersFromPartnerCount"
                          }
                        })
                      : _c("span", { staticClass: "right" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatNumber")(
                                partner.redirectedCustomersFromPartnerCount
                              )
                            )
                          )
                        ])
                  ],
                  1
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", [
            _c(
              "th",
              { staticClass: "disabled-background", attrs: { colspan: "2" } },
              [_vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total"))))]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(
                      _vm.customerGuidanceGrandTotals.toPartner
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(
                      _vm.customerGuidanceGrandTotals.fromPartner
                    )
                  )
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }